




















import ObjectMenuButton from "./ObjectMenuButton.vue";
import { Component, Mixins, Prop } from "vue-property-decorator";
import MovableImageObject from "../objects/MovableImageObject.vue";

@Component({
  components: {
    ObjectMenuButton, 
  }
})

export default class MovableImageObjectMenu extends Mixins() {
  @Prop()
  source: MovableImageObject;

  @Prop()
  isImageRegistrationEnable: boolean;

  get isEditableImage(): boolean {
    return this.$store.getters.configuration.behavior.document.editor.contents.claio.edit.isEnable
      && this.source.isEditableClaioImage;
  }

  get isClaioSchemaEditableImage(): boolean {
    return this.source.isClaioSchemaEditableImage;
  }

  get isTrimmableImage(): boolean {
    return this.$configuration.behavior.document.editor.imageEditor.trimming.isEnable && this.source.isTrimmableImage;
  }

  trimImage(): void {
    this.source.trimImage();
  }

  editImage(): void {
    this.source.editImage();
  }

  editImages(): void {
    this.source.editImages();
  }

  editImagebyClaioSchema(): void {
    this.source.editClaioSchemaWhenNeeded(false);
  }
  
  get isErasable(): boolean {
    return this.$store.getters.configuration.behavior.document.editor.eraser.isEnable
        && this.source.isErasable;
  }

  eraseImage(): void {
    this.source.eraseImage();
  }
}
